import { render, staticRenderFns } from "./certificats-medicaux.html?vue&type=template&id=1f2c8ea6&scoped=true&external"
import script from "./certificats-medicaux.js?vue&type=script&lang=js&external"
export * from "./certificats-medicaux.js?vue&type=script&lang=js&external"
import style0 from "./certificats-medicaux.scss?vue&type=style&index=0&id=1f2c8ea6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c8ea6",
  null
  
)

export default component.exports